import React from 'react'

import Content from 'components/base/Content'
import Title from 'components/base/Title'
import Paragraph, { Theme as ParagraphTheme } from 'components/base/Paragraph'

import SuggestInsuranceForm from 'components/blocks/SuggestInsuranceForm'

import QuotingWrapper, { Theme as QuotingWrapperTheme } from 'components/blocks/QuotingWrapper'

const SuggestInsuranceScreen: React.FC = (): React.ReactElement => (
  <QuotingWrapper noPadding={true} theme={QuotingWrapperTheme.concierge} title='Hi!'>
    <Title level={3}>Something Missing?</Title>
    <Content margined={true} center={true} short={true}>
      <Paragraph theme={ParagraphTheme.intro}>
        If you don’t see what you’re looking for, please enter your email
        address and a brief description and we will reach out when we offer
        the insurance type you’re seeking in your state.
      </Paragraph>
      <SuggestInsuranceForm />
    </Content>
  </QuotingWrapper>
)

export default SuggestInsuranceScreen
